export default "__VITE_ASSET__DZ1GI1M7__"